/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamExamitemidExamList200,
  GetApiV1ExamExamitemidExamList400,
  GetApiV1ExamExamitemidExamList401,
  GetApiV1ExamExamitemidExamList500,
  GetApiV1ExamExamitemidExamListPathParams,
  GetApiV1ExamExamitemidExamListQueryParams,
  GetApiV1ExamExamitemidExamListQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidExamList.ts";
import { examListForItemRepositoryResponsePaginatedResponseSchema } from "../examListForItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamExamitemidExamListPathParamsSchema = z.object({
  examItemId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamExamitemidExamListPathParams>;

export const getApiV1ExamExamitemidExamListQueryParamsSchema = z
  .object({
    DisciplineId: z.optional(z.coerce.number().int()),
    CompanyId: z.optional(z.coerce.number().int()),
    PageNumber: z.optional(z.coerce.number().int()),
    PageSize: z.optional(z.coerce.number().int()),
    SortField: z.optional(z.string()),
    SortDirection: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamExamitemidExamListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamExamitemidExamList200Schema = z.lazy(
  () => examListForItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamExamitemidExamList200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamExamitemidExamList400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidExamList400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamExamitemidExamList401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidExamList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamExamitemidExamList500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamExamitemidExamList500>;

export const getApiV1ExamExamitemidExamListQueryResponseSchema = z.lazy(
  () => getApiV1ExamExamitemidExamList200Schema,
) as unknown as ToZod<GetApiV1ExamExamitemidExamListQueryResponse>;
